import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ItemList from 'flarum/common/utils/ItemList';
import PollGroupListItem from './PollGroup/PollGroupListItem';
import PollPageHero from './PollPageHero';
export default class PollGroupViewPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "pollGroup", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('canViewPollGroups')) {
      m.route.set('/');
      return;
    }
    const editId = m.route.param('id');
    this.pollGroup = app.store.getById('poll_groups', editId) || null;
    if (!this.pollGroup) {
      this.loading = true;
      app.store.find('poll_groups', editId).then(item => {
        this.pollGroup = item;
        this.loading = false;
        app.setTitle(this.pollGroup.name());
        m.redraw();
      });
    }
  }
  view() {
    return m(PageStructure, {
      className: "PollGroupViewPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: this.loading
    }, this.contentItems().toArray());
  }
  hero() {
    return m(PollPageHero, {
      title: app.translator.trans('fof-polls.forum.poll_groups.list_page.title'),
      icon: "fas fa-layer-group"
    });
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  contentItems() {
    const items = new ItemList();
    if (this.pollGroup) {
      items.add('pollGroup', m(PollGroupListItem, {
        pollGroup: this.pollGroup
      }));
    }
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollGroupViewPage', PollGroupViewPage);